import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

export function OfflineStatusBadge() {
  const { isOffline } = useOnlineStatus();

  if (!isOffline) return null;

  return (
    <div
      className="offline-status-badge inline-flex h-8 shrink-0 items-center gap-1.5 rounded-md border px-2.5 text-xs font-medium"
      title="You are offline. Editing is disabled until your connection is restored."
    >
      <WifiOff className="h-3.5 w-3.5" />
      <span className="hidden sm:inline">Offline</span>
    </div>
  );
}
